export const GET_REGISTRANT_LIST_REQUEST = 'Registrants/GET_REGISTRANT_LIST_REQUEST';
export const GET_REGISTRANT_LIST_SUCCESS = 'Registrants/GET_REGISTRANT_LIST_SUCCESS';
export const GET_REGISTRANT_LIST_FAILURE = 'Registrants/GET_REGISTRANT_LIST_FAILURE';
